import { useNavigate } from 'react-router-dom'

import { Box, Icon, Tag, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { useCostCenterMemberships } from 'modules/expenses/hooks/useCostCenterMemberships'

interface CostCentersProps {
  activeOn: Date
  employeeId?: number
}

const CostCenters = ({ employeeId, activeOn }: CostCentersProps) => {
  const [open, toggle] = useToggle(false)
  const { loading, memberships } = useCostCenterMemberships(activeOn, employeeId)
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  if (loading || memberships.length === 0) return null

  return (
    <Box paddingBottom="s8" flexDirection="column">
      <Box paddingBottom="s4" flexDirection="row" alignItems="center" gap="s8">
        <Text.Normal size="200" weight="medium" color="grey1000">
          {i18n.t('expenses_v2.forms.fields.cost_centers.label')}
        </Text.Normal>
        <Tooltip.CallToAction
          attachment="bottom center"
          textAlign="center"
          open={open}
          toggle={toggle}
          title={i18n.t('expenses_v2.forms.fields.cost_centers.tooltip.title')}
          description={i18n.t('expenses_v2.forms.fields.cost_centers.tooltip.description')}
          buttonLabel={i18n.t('expenses_v2.forms.fields.cost_centers.tooltip.button_label')}
          onClick={() => navigate(navigation.settings.finance.costCenters.fullPath())}
        >
          <Icon.Small icon="question" encircled="grey800" />
        </Tooltip.CallToAction>
      </Box>
      <Box flexDirection="row" alignItems="flexStart" flexWrap="wrap" gap="s8">
        {memberships.map((membership) => (
          <Tag key={membership.id}>
            {membership.costCenter.name} ({membership.percentage}%)
          </Tag>
        ))}
      </Box>
    </Box>
  )
}

export default observer(CostCenters)
